module.exports = __webpack_public_path__ + "static/media/mail.40af7c43.svg";